module.exports = __webpack_public_path__ + "static/media/S2.91142c55.jpg";